import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const isDeveloping = process.env.NODE_ENV !== 'production';

const TranslateError = ({ children }) => {
  const { i18n, t } = useTranslation();

  if (i18n.exists(children)) {
    return t(children);
  }

  if (isDeveloping) {
    return children;
  }

  return t('common:error.common');
};

TranslateError.propTypes = {
  children: PropTypes.string.isRequired
};

export default TranslateError;
